import React from 'react';

const DealerIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">
                        unknown_document
                  </span>
            </>
      );
};

export default DealerIcon;
